const EXPANDED_CLASS = 'is-expanded';

export default class WCProductShowMore {
    constructor() {
        this.readMoreBtns = [...document.querySelectorAll('.jsReadMoreBtn')];

        if (this.readMoreBtns.length) {
            this.events();
        }
    }

    events() {
        this.readMoreBtns.forEach((btn) =>
            btn.addEventListener('click', this.toggleShowMoreItem.bind(this)),
        );
    }

    toggleShowMoreItem(e) {
        const clickedBtn = e.currentTarget;
        const targetId = clickedBtn.getAttribute('aria-controls');

        if (!targetId) return;

        const target = document.getElementById(targetId);

        if (
            !target ||
            !(
                target.classList.contains('jsReadMoreText') ||
                target.classList.contains('jsReadMoreList')
            )
        )
            return;

        const isExpanded = target.classList.toggle(EXPANDED_CLASS);

        this.changeButtonState(clickedBtn, isExpanded);
    }

    changeButtonState(btn, isExpanded) {
        const btnText = btn.querySelector('.jsReadMoreBtnText');

        btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

        if (!btnText) return;

        const label = isExpanded
            ? btnText.dataset.showLess
            : btnText.dataset.showMore;

        if (label) btnText.innerText = label;
    }
}
